import React from "react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_weigh-away/artifacts/010vi2mb_Weigh%20Away.png";

// Image-based logo (provided by client). Pre-composed with text and tagline.
export default function Logo({ size = 44, className = "", showText = false }) {
  return (
    <img
      src={LOGO_URL}
      alt="Weigh Away — Pay only for what we take"
      height={size}
      style={{ height: size, width: "auto" }}
      className={className}
      data-testid="weigh-away-logo"
    />
  );
}

// eslint-disable-next-line no-unused-vars
export const LOGO_IMAGE_URL = LOGO_URL;
